<div class="container mainbox">
    <form [formGroup]="issueForm">
        <h1 class="form-group title-position" style="margin-top: 20px;" translate>corporateClientBilling.title</h1>

        <div class="card">
            <div class="card-header">
                <h5 class="mb-0" translate>promoCampaignConfig.mainSection</h5>
            </div>
            <div class="card-body">
                <div class="container-fluid row">

                    <!-- date from -->
                    <div class="col-lg-4 col-md-6">
                        <div style="width: 200pt">
                            <label style="margin-top: 12px;" translate>corporateClientBilling.dateFrom</label>
                            <div class="input-group">
                                <input class="form-control" aria-describedby="ccbDateFrom"
                                    formControlName="dateFrom" ngbDatepicker #dFrom="ngbDatepicker" readonly
                                    [ngClass]="{ 'is-invalid': showValidations && f.dateFrom.errors }">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary fa fa-calendar" (click)="dFrom.toggle()" type="button"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- date to -->
                    <div class="col-lg-4 col-md-6">
                        <div style="width: 200pt">
                            <label style="margin-top: 12px;" translate>corporateClientBilling.dateTo</label>
                            <div class="input-group">
                                <input class="form-control" aria-describedby="ccbDateTo"
                                    formControlName="dateTo" ngbDatepicker #dTo="ngbDatepicker" readonly
                                    [ngClass]="{ 'is-invalid': showValidations && f.dateTo.errors }">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary fa fa-calendar" (click)="dTo.toggle()" type="button"></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- subject version (autocomplete) -->
                    <div class="col-lg-4 col-md-6">
                        <div style="width: 200pt">
                            <label style="margin-top: 12px;" translate>corporateClientBilling.subjectVersion</label>
                            <input type="text" class="form-control" formControlName="subjectVersion"
                                [ngbTypeahead]="subjectVersionsSearch" [inputFormatter]="subjectVersionFormatter"
                                [resultTemplate]="rtsv"
                                [ngClass]="{ 'is-invalid': showValidations && f.subjectVersion.errors }" />
                            <ng-template #rtsv let-r="result" let-t="term">
                                <ngb-highlight [result]="r.fullName" [term]="t"></ngb-highlight>
                                <small *ngIf="r.identNum" class="text-muted ml-2">
                                    (<ngb-highlight [result]="r.identNum" [term]="t"></ngb-highlight>)
                                </small>
                            </ng-template>
                        </div>
                    </div>

                    <!-- accounting document number -->
                    <div class="col-lg-4 col-md-6">
                        <div style="width: 200pt">
                            <label style="margin-top: 12px;" translate>corporateClientBilling.accDocNumber</label>
                            <input type="text" class="form-control" formControlName="accDocNumber" appTrimWhitespace
                                (blur)="onAccDocNumberBlur()"
                                [ngClass]="{ 'is-invalid': (showValidations && f.accDocNumber.errors) || accDocNotFound || accDocInvalidStatus }">
                            <small class="form-text text-success" *ngIf="accDocFoundLabel && !accDocInvalidStatus">
                                <span translate>corporateClientBilling.docFound</span>: {{ accDocFoundLabel }}
                            </small>
                            <small class="form-text text-danger" *ngIf="accDocNotFound" translate>
                                corporateClientBilling.docNotFound
                            </small>
                            <small class="form-text text-danger" *ngIf="accDocInvalidStatus" translate>
                                corporateClientBilling.docInvalidStatus
                            </small>
                        </div>
                    </div>

                    <!-- modification model -->
                    <div class="col-lg-4 col-md-6">
                        <div style="width: 200pt">
                            <label style="margin-top: 12px;" translate>corporateClientBilling.modificationModel</label>
                            <select class="custom-select" formControlName="modificationModelId"
                                [ngClass]="{ 'is-invalid': showValidations && f.modificationModelId.errors }">
                                <option [ngValue]="null" translate>placeholder.select</option>
                                <option *ngFor="let model of modificationModels" [ngValue]="model.id">
                                    {{ model.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- actions -->
        <div class="input-group mt-3">
            <button class="btn btn-outline-success" type="button" (click)="issue()" [disabled]="submitting" translate>
                corporateClientBilling.issue
            </button>
        </div>

        <!-- issuing spinner -->
        <div *ngIf="submitting" class="d-flex align-items-center mt-3">
            <span class="spinner-border spinner-border-sm text-primary mr-2" role="status" aria-hidden="true"></span>
            <span translate>corporateClientBilling.issuing</span>
        </div>

        <!-- issued result -->
        <div *ngIf="!submitting && issuedResult" class="card mt-3">
            <div class="card-body py-2">
                <div class="d-flex align-items-center flex-wrap">
                    <div class="mr-3">
                        <strong translate>corporateClientBilling.invoiceNumber</strong>: {{ issuedResult.invoiceNumber }}
                    </div>
                    <div class="mr-3">
                        <strong translate>corporateClientBilling.recipient</strong>: {{ issuedResult.recipientFullName }}
                    </div>
                    <button type="button" class="btn btn-outline-primary btn-sm ccb-action-btn" (click)="viewIssuedDoc()">
                        <span translate>corporateClientBilling.view</span>
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm ccb-action-btn" (click)="downloadIssuedDoc()"
                        [disabled]="isDownloadingPdf">
                        <span *ngIf="!isDownloadingPdf" translate>corporateClientBilling.download</span>
                        <span *ngIf="isDownloadingPdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm ccb-action-btn" (click)="downloadProtocolPdf()"
                        [disabled]="isDownloadingProtocolPdf">
                        <span *ngIf="!isDownloadingProtocolPdf">ППП</span>
                        <span *ngIf="isDownloadingProtocolPdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
